import Reveal from './ui/Reveal';
import Icon from './ui/Icon';
import SectionHeading from './ui/SectionHeading';
import { processSteps } from '../data/content';

const Process = () => (
  <section id="process" className="section border-t border-white/[0.06]" aria-labelledby="process-title">
    <div className="container-page">
      <SectionHeading
        id="process-title"
        eyebrow="How it works"
        title="A simple process, from first call to launch"
        lead="Clear steps, plain language and no surprises, so you always know what happens next."
      />

      <ol className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {processSteps.map((step, i) => (
          <Reveal as="li" key={step.number} delay={i * 90}>
            <div className="card card-hover relative h-full p-6">
              <div className="flex items-center justify-between">
                <span className="grid h-[54px] w-[54px] place-items-center rounded-2xl border border-indigo-300/25 bg-ink-800 text-indigo-300">
                  <Icon name={step.icon} className="h-6 w-6" />
                </span>
                <span className="font-mono text-sm font-medium text-subtle">{step.number}</span>
              </div>
              <h3 className="mt-6 text-lg font-semibold tracking-tight text-fg">{step.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted">{step.description}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default Process;
